import { createContext, useContext, useState, useEffect } from 'react';

const LanguageContext = createContext(null);

const translations = {
    id: {
        // Navigation
        dashboard: 'Dashboard',
        learningPath: 'Learning Path',
        marketInsight: 'Market Insight',
        checklist: 'Checklist / SOP',
        resourceVault: 'Resource Vault',
        liveSession: 'Live Session',
        certificate: 'Sertifikat',
        settings: 'Pengaturan',
        logout: 'Keluar',
        
        // Levels
        basic: 'Basic',
        intermediate: 'Intermediate',
        advanced: 'Advanced',
        expert: 'Expert',
        
        // Market Insight Categories
        weeklyBias: 'Weekly Bias',
        keyZones: 'Key Zones',
        newsImpact: 'News Impact',
        
        // Checklist Categories
        preTrade: 'Pre-Trade',
        postTrade: 'Post-Trade',
        riskRules: 'Risk Rules',
        
        // Resource Categories
        pdfNotes: 'PDF Notes',
        tradingPlan: 'Trading Plan',
        riskCalculator: 'Risk Calculator',
        tradingJournal: 'Trading Journal',
        
        // Live Session Categories
        weeklyReview: 'Weekly Review',
        qaReplay: 'Q&A Replay',
        
        // Dashboard
        welcomeBack: 'Selamat Datang Kembali',
        totalProgress: 'Total Progress',
        currentLevel: 'Level Saat Ini',
        continueLesson: 'Lanjutkan Lesson',
        lastWatched: 'Terakhir Ditonton',
        quickStats: 'Statistik Cepat',
        lessonsCompleted: 'Lesson Selesai',
        hoursLearned: 'Jam Belajar',
        badgesEarned: 'Badge Diperoleh',
        
        // Learning
        locked: 'Terkunci',
        completed: 'Selesai',
        inProgress: 'Sedang Berjalan',
        startLesson: 'Mulai Lesson',
        continueWatching: 'Lanjutkan Menonton',
        markAsComplete: 'Tandai Selesai',
        nextLesson: 'Lesson Berikutnya',
        previousLesson: 'Lesson Sebelumnya',
        lessons: 'Lesson',
        chapters: 'Chapter',
        duration: 'Durasi',
        minutes: 'menit',
        
        // Video Player
        playbackSpeed: 'Kecepatan',
        
        // Checklist
        dailyChecklist: 'Checklist Harian',
        resetChecklist: 'Reset Checklist',
        checklistDescription: 'Pastikan kamu mengikuti checklist ini sebelum dan sesudah trading',
        
        // Resources
        download: 'Download',
        downloads: 'downloads',
        
        // Certificates
        myCertificates: 'Sertifikat Saya',
        myBadges: 'Badge Saya',
        noCertificates: 'Belum ada sertifikat',
        completeTo: 'Selesaikan level Expert untuk mendapatkan sertifikat',
        certificateNumber: 'Nomor Sertifikat',
        issuedOn: 'Diterbitkan pada',
        
        // Search
        searchPlaceholder: 'Cari lesson, insight, resource...',
        searchResults: 'Hasil Pencarian',
        noResults: 'Tidak ada hasil ditemukan',
        
        // Auth
        login: 'Masuk',
        register: 'Daftar',
        email: 'Email',
        password: 'Password',
        name: 'Nama',
        forgotPassword: 'Lupa Password?',
        noAccount: 'Belum punya akun?',
        haveAccount: 'Sudah punya akun?',
        
        // Admin
        adminPanel: 'Admin Panel',
        manageContent: 'Kelola Konten',
        addNew: 'Tambah Baru',
        edit: 'Edit',
        delete: 'Hapus',
        save: 'Simpan',
        cancel: 'Batal',
        
        // General
        loading: 'Memuat...',
        error: 'Terjadi kesalahan',
        success: 'Berhasil',
        confirm: 'Konfirmasi',
        back: 'Kembali',
        viewAll: 'Lihat Semua',
        filter: 'Filter',
        sort: 'Urutkan'
    },
    en: {
        // Navigation
        dashboard: 'Dashboard',
        learningPath: 'Learning Path',
        marketInsight: 'Market Insight',
        checklist: 'Checklist / SOP',
        resourceVault: 'Resource Vault',
        liveSession: 'Live Session',
        certificate: 'Certificate',
        settings: 'Settings',
        logout: 'Logout',
        
        // Levels
        basic: 'Basic',
        intermediate: 'Intermediate',
        advanced: 'Advanced',
        expert: 'Expert',
        
        // Market Insight Categories
        weeklyBias: 'Weekly Bias',
        keyZones: 'Key Zones',
        newsImpact: 'News Impact',
        
        // Checklist Categories
        preTrade: 'Pre-Trade',
        postTrade: 'Post-Trade',
        riskRules: 'Risk Rules',
        
        // Resource Categories
        pdfNotes: 'PDF Notes',
        tradingPlan: 'Trading Plan',
        riskCalculator: 'Risk Calculator',
        tradingJournal: 'Trading Journal',
        
        // Live Session Categories
        weeklyReview: 'Weekly Review',
        qaReplay: 'Q&A Replay',
        
        // Dashboard
        welcomeBack: 'Welcome Back',
        totalProgress: 'Total Progress',
        currentLevel: 'Current Level',
        continueLesson: 'Continue Lesson',
        lastWatched: 'Last Watched',
        quickStats: 'Quick Stats',
        lessonsCompleted: 'Lessons Completed',
        hoursLearned: 'Hours Learned',
        badgesEarned: 'Badges Earned',
        
        // Learning
        locked: 'Locked',
        completed: 'Completed',
        inProgress: 'In Progress',
        startLesson: 'Start Lesson',
        continueWatching: 'Continue Watching',
        markAsComplete: 'Mark as Complete',
        nextLesson: 'Next Lesson',
        previousLesson: 'Previous Lesson',
        lessons: 'Lessons',
        chapters: 'Chapters',
        duration: 'Duration',
        minutes: 'minutes',
        
        // Video Player
        playbackSpeed: 'Speed',
        
        // Checklist
        dailyChecklist: 'Daily Checklist',
        resetChecklist: 'Reset Checklist',
        checklistDescription: 'Make sure to follow this checklist before and after trading',
        
        // Resources
        download: 'Download',
        downloads: 'downloads',
        
        // Certificates
        myCertificates: 'My Certificates',
        myBadges: 'My Badges',
        noCertificates: 'No certificates yet',
        completeTo: 'Complete Expert level to earn certificate',
        certificateNumber: 'Certificate Number',
        issuedOn: 'Issued on',
        
        // Search
        searchPlaceholder: 'Search lessons, insights, resources...',
        searchResults: 'Search Results',
        noResults: 'No results found',
        
        // Auth
        login: 'Login',
        register: 'Register',
        email: 'Email',
        password: 'Password',
        name: 'Name',
        forgotPassword: 'Forgot Password?',
        noAccount: "Don't have an account?",
        haveAccount: 'Already have an account?',
        
        // Admin
        adminPanel: 'Admin Panel',
        manageContent: 'Manage Content',
        addNew: 'Add New',
        edit: 'Edit',
        delete: 'Delete',
        save: 'Save',
        cancel: 'Cancel',
        
        // General
        loading: 'Loading...',
        error: 'An error occurred',
        success: 'Success',
        confirm: 'Confirm',
        back: 'Back',
        viewAll: 'View All',
        filter: 'Filter',
        sort: 'Sort'
    }
};

export const LanguageProvider = ({ children }) => {
    const [language, setLanguage] = useState(() => {
        return localStorage.getItem('nusatrade_lang') || 'id';
    });

    useEffect(() => {
        localStorage.setItem('nusatrade_lang', language);
    }, [language]);

    const t = (key) => {
        return translations[language][key] || key;
    };

    const getLocalizedField = (item, field) => {
        if (!item) return '';
        if (language === 'en' && item[`${field}_en`]) {
            return item[`${field}_en`];
        }
        return item[field] || '';
    };

    const toggleLanguage = () => {
        setLanguage(prev => prev === 'id' ? 'en' : 'id');
    };

    return (
        <LanguageContext.Provider value={{
            language,
            setLanguage,
            toggleLanguage,
            t,
            getLocalizedField
        }}>
            {children}
        </LanguageContext.Provider>
    );
};

export const useLanguage = () => {
    const context = useContext(LanguageContext);
    if (!context) {
        throw new Error('useLanguage must be used within a LanguageProvider');
    }
    return context;
};
